import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import backArrowImg from "../../recommendation/assets/images/common/recommand_right-arrow.png";

import "../styles/LearningRoomHeaderViewStyles.css";
import quesIcon from "../../sidebar/assets/blueQuesIcon.png";
import { useSelector } from "react-redux";

import { logActionEvent } from "../../../analytics/analytics_utils";
import analytics_strings from "../../../analytics/analytics_strings";
import { RootState } from "../../../store/store";
import LearningRoomNeedHelpRightModal from "./LearningRoomNeedHelpModel";
import GreyHorizontalDivider from "./GreyDividerComponent";
interface ProgramHubViewHeaderProps {
  description?: string;
  text?: string;
  onClick?: () => void;
  isVideoPage?: boolean;
}

const LearningRoomViewHeader: React.FC<ProgramHubViewHeaderProps> = ({
  description,
  text,
  onClick,
  isVideoPage = false,
}) => {
  const [isModalOpen, setModalOpen] = useState(false);
  // Select the data from the Redux store
  const userData = useSelector((state: RootState) => state.profile.profileKeys);
  const toggleModal = () => {
    setModalOpen(!isModalOpen);
    if (!isModalOpen) {
      logActionEvent(
        analytics_strings.analytics_events.reccomendation_needHelp,
        {
          candidate_id: userData.candidate_id,
        },
      );
    }
  };
  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "start",
          justifyContent: "space-between",
          boxShadow: "0 4px 8px rgba(105, 103, 103, 0.1)", // Bottom box shadow
          padding: "20px",
          paddingRight: "0px",
          // zIndex: 10000,
          marginBottom: "10px",
        }}
        className="header-container"
      >
        <div className="home-section">
          {onClick && (
            <div className="back-arrow-container" onClick={onClick}>
              <img
                src={backArrowImg}
                alt="Back"
                style={{
                  width: "24px",
                  height: "24px",
                  // marginRight: "8px",
                  cursor: "pointer",
                  alignItems: "center",
                }}
                onClick={onClick}
              />
            </div>
          )}
          <div>
            <span
              style={{
                marginLeft: "10px",
                color: "#121212",
                fontWeight: 500,
                fontSize: "20px",
              }}
              className="home-text"
            >
              {text ?? "Learning Room"}
            </span>
            {!isVideoPage && (
              <div
                style={{
                  marginLeft: "10px",
                  color: "#344054",
                  fontSize: "14px",
                  fontWeight: 300,
                }}
                className="home-text"
              >
                {description ??
                  "Hey there, it’s time for a quick learning progress check."}
              </div>
            )}
          </div>
        </div>
        <img
          src={quesIcon} // put your image path here
          alt="Recommendations"
          style={{
            width: "40px",
            height: "40px", // adjust size as needed
            marginRight: "30px",
            cursor: "pointer",
          }}
          onClick={() => {
            toggleModal();
          }}
        />
      </div>
      <LearningRoomNeedHelpRightModal
        isOpen={isModalOpen}
        toggleModal={toggleModal}
      />{" "}
      {/* <GreyHorizontalDivider /> */}
    </div>
  );
};

export default LearningRoomViewHeader;
